export const AI_VIDEO_REVIEW = {
  BASE: 'api/ai-video-review',
  AI_VIDEO_REVIEW_COUNTS: () => `${AI_VIDEO_REVIEW.BASE}/counts`,
};